import { Enquete } from "@muscat/types";
import { maxAnswered } from "./max-answers";

const completeMessage = `
<div style="background-color: white;margin-left:30px; margin-right: 30px; padding: 50px; text-align: left;" >アンケートは以上です。
この度はアンケートへのご協力ありがとうございました。
回答いただきました内容やご意見は、アンケート主催企業/団体の今後の商品開発やサービス改善等の参考にさせていただきます。
なお、本アンケートで知りえた内容は、口頭、SNS（X[旧Twitter],Instagram,Facebook,LINE等）等のいかなる手段であっても<b><font color="red">アンケート内容の『第三者への漏えい（再拡散を含む）』『保存』『転載』行為を禁止</font></b>しています。

もし上記の禁止行為が確認された場合、<b><font color="red">損害賠償請求・民事訴訟の対象となる場合がございます</font></b>ので十分にご注意下さい。

<div style="border: solid 1px #ccc; text-align: center;font-size: 80%; margin: 20px; padding: 20px;">調査ID：「LK●●●（●には数字が入ります）」アンケート名：「日用品に関するアンケート」は、一つ回答を頂くと同一名称のアンケートは「回答済みです」と表示がされ回答ができなくなるものがございます。
こちらは、不具合ではなく本アンケートの仕様によるものでございます。
お客様にはご迷惑をおかけいたしますが、ご了承を頂けますと幸いです。
</div></div>`;

/**
 * - コンセプトアセスメントのベースアンケート
 */
export const baseEnquete: Enquete = {
	enqueteId: "",
	title: "日用品に関するアンケート",
	// ポイントは自動計算処理が入る
	monitasDeliverSystem: {
		point: { max: 20, min: 0 },
	},
	language: "japanese",
	status: "debug", // デバッグモードで作成。
	terminatePage: [
		{ code: "fin1", body: "ご協力いただきありがとうございます。", status: "SC" },
		{ code: "complete", body: completeMessage, status: "COMP" },
	],
	// 設問は別で入れ込む
	questionnaire: [],
	maxAnswers: maxAnswered,
};
